import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { Wrapper } from './styled';

import { NoticeCard } from 'components/NoticeCard';
import { useMediaQuery } from 'helpers/mediaQuery';

export function NotFoundLayout() {
  const { t } = useTranslation();

  const isScreenSm = useMediaQuery({ maxWidth: 'sm' });

  return (
    <Wrapper>
      <div className={cn('flex justify-center', { 'py-12': !isScreenSm })}>
        <NoticeCard
          text={t('page.notFound.noticeCard.data.text')}
          title={t('page.notFound.noticeCard.data.title')}
        />
      </div>
    </Wrapper>
  );
}
